import { render, staticRenderFns } from "./BatchOperateEditGroup.vue?vue&type=template&id=71c153f5&scoped=true"
import script from "./BatchOperateEditGroup.vue?vue&type=script&lang=ts"
export * from "./BatchOperateEditGroup.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateEditGroup.vue?vue&type=style&index=0&id=71c153f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c153f5",
  null
  
)

export default component.exports